import * as Yup from 'yup';
import { ScenarioInput } from 'src/graphql/_generated';
import { CHAR_LIMITS, charLimitError } from 'src/config';

export const scenarioValidationSchema = Yup.object({
  name: Yup.string().required('Required').max(CHAR_LIMITS.scenarioName, charLimitError('Name')),
  source: Yup.number().nullable(),
  event: Yup.number().nullable(),
  consequence: Yup.number().nullable(),
  riskNarrative: Yup.string().nullable(),
  frequencyTimes: Yup.number().nullable(),
  frequencyYears: Yup.number().nullable(),
  frequencyNote: Yup.string().nullable().max(CHAR_LIMITS.scenarioNote, charLimitError('Frequency - Note')),
  upperFormula: Yup.string(),
  lowerFormula: Yup.string(),
  consequenceNote: Yup.string().nullable().max(CHAR_LIMITS.scenarioNote, charLimitError('Consequence - Note')),
  riskIdentifiedDate: Yup.string().nullable(),
  reviewDate: Yup.string().nullable(),
  status: Yup.string().nullable(),
  managementStrategy: Yup.string().nullable(),
  managementNote: Yup.string().nullable().max(CHAR_LIMITS.scenarioNote, charLimitError('Note')),
});

export const scenarioInitialValues: ScenarioInput = {
  name: '',
  source: undefined,
  event: undefined,
  consequence: undefined,
  riskOwner: null,
  riskNarrative: '',
  frequencyTimes: undefined,
  frequencyYears: undefined,
  frequencyNote: '',
  upper: undefined,
  lower: undefined,
  upperFormula: '',
  lowerFormula: '',
  consequenceNote: '',
  riskIdentifiedDate: null,
  reviewDate: null,
  status: 'Draft',
};
